import { type ModuleData, ModuleProvider, useModule } from '#providers'
import { ApplicantProvidedDocumentConfiguration } from '../../types/authenticateSmartcheckSessionDto'
import {
	IncomeVerificationDto,
	IncomeVerificationFormData,
} from './IncomeVerification.types'

interface IncomeVerificationConfig {
	applicantProvidedDocumentConfigurations:
		| readonly ApplicantProvidedDocumentConfiguration[]
		| undefined
	shouldAllowFileUpload: boolean
	shouldShowConsumerNote: boolean
}

interface IncomeVerificationData
	extends Omit<
		IncomeVerificationDto,
		'incomeVerificationPreviouslyCompleted'
	> {}

export type IncomeVerificationModuleData = ModuleData<
	IncomeVerificationData,
	IncomeVerificationFormData,
	IncomeVerificationConfig
>

export const IncomeVerificationModuleProvider: typeof ModuleProvider<IncomeVerificationModuleData> =
	ModuleProvider

export const useIncomeVerificationModule: typeof useModule<IncomeVerificationModuleData> =
	useModule
